function addProductRecommendationsToSearch() {
  const searchParent = document.querySelector(".site-header__search-container");
  const recommendationsSection = document.querySelector(".product-recommendations-section");
  if (searchParent && recommendationsSection) {
    const clone = recommendationsSection.cloneNode(true);
    clone.classList.add("search-product-recommendations");
    searchParent.appendChild(clone);
  }
}

function removeProductRecommendationsFromSearch() {
  const existingRecommendations = document.querySelector(".site-header__search-container .product-recommendations-section");
  if (existingRecommendations) {
    existingRecommendations.remove();
  }
}

function addProductRecommendationsToEmptyCart() {
  const emptyCartParent = document.querySelector(".drawer__cart-empty");
  const recommendationsSection = document.querySelector(".product-recommendations-section");
  if (emptyCartParent && recommendationsSection) {
    const clone = recommendationsSection.cloneNode(true);
    clone.classList.add("cart-product-recommendations");
    emptyCartParent.appendChild(clone);
  }
}

function removeProductRecommendationsFromCart() {
  const existingRecommendations = document.querySelector(".drawer__cart-empty .product-recommendations-section");
  if (existingRecommendations) {
    existingRecommendations.remove();
  }
}
document.addEventListener("predictive-search:open", function () {
  addProductRecommendationsToSearch();
});

document.addEventListener("predictive-search:close-all", function () {
  console.log("close");
  removeProductRecommendationsFromSearch();
});

document.addEventListener("drawerOpen.CartDrawer", function () {
  addProductRecommendationsToEmptyCart();
});

document.addEventListener("drawerClose.CartDrawer", function () {
  removeProductRecommendationsFromCart();
});

document.addEventListener("predictive-search:perform-search", function () {
  removeProductRecommendationsFromSearch();
});
